import { ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Disclaimer({ items, testId }) {
  const { t } = useApp();
  return (
    <div className="rounded-2xl border border-amber-200/20 bg-amber-200/[0.06] p-5" data-testid={testId}>
      <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber-200">
        <ShieldCheck className="h-4 w-4" /> {t("disclaimer")}
      </p>
      <ol className="list-decimal space-y-2 pl-5 text-sm leading-relaxed text-emerald-50/85">
        {items.map((it, i) => (
          <li key={i}>{it}</li>
        ))}
      </ol>
    </div>
  );
}
